<div class="admin-page-container">

  <admin-toolbar class="admin-toolbar" (toggleSidebar)="toggleSidebar()" section="Users"></admin-toolbar>

  <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

    <mat-sidenav #adminsidenav class="admin-sidebar">

      <admin-sidebar></admin-sidebar>

    </mat-sidenav>

    <mat-sidenav-content>

      <!-- [START] page content -->

      <mat-card style="width: 100%; display: block;">

        <mat-card-header>
          <mat-card-title>Users</mat-card-title>
        </mat-card-header>

        <mat-card-content style="padding-left: 16px;">

          <p>From this complete list of users you can manage their status, delete or un-delete, approve and promote to administrator if required.</p>

          <p>To Edit a user, click through the userid of that user.</p>

          <p-table  selectionMode="single"  dataKey="userid"  [value]="userList" (sortFunction)="tableSort($event)" [customSort]="true">

            <ng-template pTemplate="header">
              <tr style="background-color: #2D323D;">
                <th width="80" pSortableColumn="id"      >ID      <p-sortIcon field="id"      ></p-sortIcon></th>
                <th pSortableColumn="userid"  >userid  <p-sortIcon field="userid"  ></p-sortIcon></th>
                <th pSortableColumn="display_name"    >Name    <p-sortIcon field="display_name"    ></p-sortIcon></th>
                <th pSortableColumn="email"   >eMail   <p-sortIcon field="email"   ></p-sortIcon></th>
                <th                            >Status                                             </th>
                <th width="100" pSortableColumn="files"   >Files   <p-sortIcon field="files"   ></p-sortIcon></th>
                <th width="120" pSortableColumn="usage"   >Usage   <p-sortIcon field="usage"   ></p-sortIcon></th>
                <th pSortableColumn="created_at" >Created <p-sortIcon field="created_at" ></p-sortIcon></th>
                <th                           >Actions                                            </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user>

              <tr [className]="'userListrowWrapper'" >

                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.id}}</td>

                <td *ngIf="user.is_pending" style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;"><a style="color: white; text-decoration: none; text-underline: none; font-weight: bold;" [routerLink]="['/administration/users/approve/', user.userid]">{{user.userid}}</a></td>
                <td *ngIf="!user.is_pending" style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;"><a style="color: white; text-decoration: none; text-underline: none; font-weight: bold;" [routerLink]="['/administration/users/detail/', user.userid]">{{user.userid}}</a></td>

                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.display_name}}</td>
                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.email}}</td>
                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                  <!-- if you are deleted, you can't be anything, except deleted. -->

                  <div *ngIf="user.is_deleted; then thenDeleted else elseDeleted"></div>

                  <ng-template #thenDeleted>
                    <p-tag *ngIf="user.is_deleted" severity="danger" value="Deleted" class="userlisttag"></p-tag>
                  </ng-template>

                  <ng-template #elseDeleted>
                    <p-tag *ngIf="user.is_superuser" severity="success" value="Admin" class="userlisttag"></p-tag>
                    <p-tag *ngIf="user.is_suspended" severity="success" value="Locked" class="userlisttag"></p-tag>
                    <p-tag *ngIf="user.is_pending" severity="warning" value="Pending" class="userlisttag"></p-tag>
                  </ng-template>

                </td>

                <td style="font-size: 10px;">{{user.files}}</td>
                <td style="font-size: 10px;">{{user.usage}}</td>
                <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.created_at}}</td>
                <td style="font-size: 10px;">

                  <div *ngIf="user.is_pending; then thenPending else elsePending"></div>

                  <ng-template #thenPending>

                    <!-- pending users must be approved before you can do anything with them -->

                    <a class="useractionicon" [routerLink]="['/administration/users/approve/', user.userid]">
                      <img width="16" src="assets/images/check-64.png">
                    </a>

                  </ng-template>

                  <ng-template #elsePending>

                    <div *ngIf="user.is_deleted; then thenBlock else elseBlock"></div>

                    <ng-template #thenBlock>

                      <!-- if the user was deleted, the ONLY thing you can do is undelete them. -->

                      <a class="useractionicon" (click)="unDeleteUser(user.userid)">
                        <img width="16" src="assets/images/undelete-64.png">
                      </a>

                    </ng-template>

                    <ng-template #elseBlock>

                      <!-- active users can be locked/unlocked, or promoted to admin or demoted from admin -->

                      <!-- promote/demote user -->
                      <div *ngIf="user.is_superuser; then thenAdmin else elseAdmin"></div>

                      <ng-template #thenAdmin>

                        <a class="useractionicon" (click)="demoteAdmin(user.userid)">
                          <img width="16" src="assets/images/promote-64.png">
                        </a>

                      </ng-template>

                      <ng-template #elseAdmin>

                        <a class="useractionicon" (click)="promoteAdmin(user.userid)">
                          <img width="16" src="assets/images/demote-64.png">
                        </a>

                      </ng-template>

                      <!-- suspend/unsuspend user -->
                      <div *ngIf="user.is_suspended; then thenLocked else elseLocked"></div>

                      <ng-template #thenLocked>

                        <a class="useractionicon" (click)="unlockUser(user.userid)">
                          <img width="16" src="assets/images/lock-64.png">
                        </a>

                      </ng-template>

                      <ng-template #elseLocked>

                        <a class="useractionicon" (click)="lockUser(user.userid)">
                          <img width="16" src="assets/images/unlock-64.png">
                        </a>

                      </ng-template>

                      <!-- active users can be deleted, but only via a secondary screen to make sure you are sure -->

                      <a class="useractionicon" (click)="deleteUser(user.userid)">
                        <img width="16" src="assets/images/delete-64.png">
                      </a>

                    </ng-template>

                  </ng-template>

                </td>
              </tr>
            </ng-template>
          </p-table>



        </mat-card-content>
      </mat-card>

      <!-- [END] page content -->

      <admin-footer section="Users"></admin-footer>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>

